// react
import { useState } from 'react';
// @mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { setError } from 'src/redux/slices/error';
import { getCurrentMemberWaitingList } from 'src/redux/slices/members';
// components
import { useSnackbar } from 'src/components/snackbar';
// localization
import { useLocales } from '../../../locales';
// api
import { WaitingListService, WaitingListDto } from '../../../api';

type Props = WaitingListDto & {
  openState: ReturnType<typeof useBoolean>;
  onWaitingListSubmit: VoidFunction;
};

export function MembershipWaitingListDialog({ openState, onWaitingListSubmit, ...other }: Props) {
  const [loading, setLoading] = useState(false);

  const currentChain = useSelector((state) => state.chain.currentChain);
  const currentGym = useSelector((state) => state.gym.currentGym);

  const dispatch = useDispatch();

  const { t } = useLocales();

  const { enqueueSnackbar } = useSnackbar();

  const handleWaitingListSubmit = async () => {
    setLoading(true);
    try {
      await WaitingListService.create({
        body: { gymId: currentGym.id, chainId: currentChain.id, ...other },
      });
    } catch (error) {
      enqueueSnackbar(t('Failed to add to waiting list!'), { variant: 'error' });
      dispatch(setError(error));
      setLoading(false);
      openState.onFalse();
      return;
    }
    onWaitingListSubmit();
    openState.onFalse();
    enqueueSnackbar(t('Sucessfully added to waiting list!'));
    dispatch(getCurrentMemberWaitingList({ id: other.ownerId! }));
    setLoading(false);
  };

  return (
    <Dialog open={openState.value} onClose={openState.onFalse}>
      <DialogTitle>{t('Waiting list')}</DialogTitle>

      <DialogContent>
        <Typography>
          {t(
            'The global amount of memberships has been reached. Would you like to at this member to the waiting list for this membership type?'
          )}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button color="primary" variant="outlined" onClick={openState.onFalse}>
          {t('Close')}
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => handleWaitingListSubmit()}
          loading={loading}
        >
          {t('Pun on waiting list')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
